import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/Login',
			name: 'Login',
			meta: { layout: 'Default' },
			component: () => import('@/components/Login')
		},
		{
			path: '/Registro',
			name: 'Registro',
			meta: { layout: 'Content' },
			component: () => import('@/components/Registro')
		},
		{
			path: '/RolesPermisos',
			name: 'RolesPermisos',
			meta: { layout: 'Content' },
			component: () => import('@/components/RolesPermisos')
		},
		{
			path: '/Resumen',
			name: 'Resumen',
			meta: { layout: 'Content' },
			component: () => import('@/components/Resumen')
		},
		{
			path: '/FichaGestion',
			name: 'FichaGestion',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichagestion/FichaGestion')
		},
		{
			path: '/Verificaciones',
			name: 'Verificaciones',
			meta: { layout: 'Content' },
			component: () => import('@/components/Verificaciones')
		},
		{
			path: '/FichaDeudor',
			name: 'FichaDeudor',
			meta: { layout: 'Content' },
			component: () => import('@/components/FichaDeudor')
		},
		{
			path: '/DetalleDocumento',
			name: 'DetalleDocumento',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichacliente/DetalleDocumento')
		},
		{
			path: '/FichaCliente',
			name: 'FichaCliente',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichacliente/FichaCliente')
		},
		{
			path: '/FichaEmpresa',
			name: 'FichaEmpresa',
			meta: { layout: 'LayoutFichaCliente' },
			component: () => import('@/components/fichacliente/FichaEmpresa')
		},
		{
			path: '/DetalleDocumentoOpen',
			name: 'DetalleDocumentoOpen',
			meta: { layout: 'LayoutFichaCliente' },
			component: () => import('@/components/fichacliente/DetalleDocumentoOpen')
		},
		{
			path: '/VO-SinVerificar',
			name: 'VO-SinVerificar',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VO-SinVerificar')
		},
		{
			path: '/VO-EnProceso',
			name: 'VO-EnProceso',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VO-EnProceso')
		},
		{
			path: '/VO-modal-precaucion',
			name: 'VO-modal-precaucion',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VO-modal-precaucion')
		},
		{
			path: '/VO-modal-error',
			name: 'VO-modal-error',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VO-modal-error')
		},
		{
			path: '/VO-modal-exito',
			name: 'VO-modal-exito',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VO-modal-exito')
		},
		{
			path: '/VistaOperaciones',
			name: 'VistaOperaciones',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaoperaciones/VistaOperaciones')
		},
		{
			path: '/Documentos',
			name: 'Documentos',
			meta: { layout: 'Content' },
			component: () => import('@/components/Documentos')
		},
		{
			path: '/FichaVerificacion',
			name: 'FichaVerificacion',
			meta: { layout: 'Content' },
			component: () => import('@/components/FichaVerificacion')
		},
		{
			path: '/FichaGestion_Acordeon',
			name: 'FichaGestion_Acordeon',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichagestion/FichaGestion_Acordeon')
		},
		{
			path: '/AsignarCliente',
			name: 'AsignarCliente',
			meta: { layout: 'Content' },
			component: () => import('@/components/AsignarCliente')
		},
		{
			path: '/EditarClienteAsignado/:id',
			name: 'EditarClienteAsignado',
			meta: { layout: 'Content' },
			component: () => import('@/components/EditarClienteAsignado')
		},
		// Componente de administracion de usuarios con ejecutivos
		{
			path: '/UsuarioEjecutivo',
			name: 'UsuarioEjecutivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/UsuarioEjecutivo/Index')
		},
		// Detalle de usuario ejecutivo
		{
			path: '/UsuarioEjecutivo/detalle/',
			name: 'UsuarioEjecutivo/detalle',
			meta: { layout: 'Content' },
			component: () => import('@/components/UsuarioEjecutivo/detalle')
		},
		{
			path: '/Mora/GestionMora',
			name: 'GestionMora',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistamora/GestionMora')
		},
		{
			path: '/Busqueda/Excel',
			name: 'Excel',
			meta: { layout: 'Content' },
			component: () => import('@/components/vistaexcel/Excel')
		},
		{
			path: '/GestionEjecutivo',
			name: 'GestionEjecutivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/GestionEjecutivo')
		},

		{
			path: '/Verificacion',
			name: 'Verificacion',
			meta: { layout: 'Content' },
			component: () => import('@/components/verificacion/Verificacion')
		},
		{
			path: '/Verificacion/Detalle',
			name: 'Detalle',
			meta: { layout: 'Content' },
			component: () => import('@/components/verificacion/DetalleOperacionDeudor')
		},
		{
			path: '/Verificacion/Detalle/DocumentoDeudor',
			name: 'Detalle/DocumentoDeudor/DocumentoDeudor',
			meta: { layout: 'Content' },
			component: () => import('@/components/verificacion/DocumentoDeudor/DocumentoDeudor')
		},
		{
			path: '/Verificacion/Detalle/DocumentoDeudor/Resumen',
			name: 'DocumentoDeudor/Resumen',
			meta: { layout: 'Content' },
			component: () => import('@/components/verificacion/DocumentoDeudor/ResumenVerificacion')
		},
		{
			path: '/Verificacion/Detalle/FichaDeudor',
			name: 'Detalle/FichaDeudor',
			meta: { layout: 'Content' },
			component: () => import('@/components/verificacion/FichaDeudor')
		},
		{
			path: '/Verificacion/FichaAprobaciones',
			name: 'Verificacion/FichaAprobaciones',
			meta: { layout: 'LayoutFichaCliente' },
			component: () => import('@/components/verificacion/FichaDeudorOpen')
		},
		// BOLSA DE PRODUCTO
		{
			path: '/Bolsa/VentaBolsa',
			name: 'VentaBolsa',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/VentaBolsa')
		},
		{
			path: '/Bolsa/BuscarDocumento',
			name: 'BuscarDocumento',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/BuscarDocumento')
		},
		{
			path: '/Bolsa/CargaMasiva',
			name: 'CargaMasiva',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/CargaMasiva')
		},
		{
			path: '/Bolsa/DocumentosPagados',
			name: 'DocumentosPagados',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/DocumentosPagados')
		},
		{
			path: '/Bolsa/CambioEstado',
			name: 'CambioEstado',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/CambioEstado')
		},
		{
			path: '/Bolsa/CambioEstadoMasivo',
			name: 'CambioEstadoMasivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/CambioEstadoMasivo')
		},
		{
			path: '/Bolsa/IntFinanciera',
			name: 'IntFinanciera',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/IntFinanciera')
		},
		{
			path: '/Bolsa/IngresoIntFinanciera',
			name: 'IngresoIntFinanciera',
			meta: { layout: 'Content' },
			component: () => import('@/components/bolsaproducto/IngresoIntFinanciera')
		},
		{
			path: '/ClasificacionDeudores',
			name: 'ClasificacionDeudores',
			meta: { layout: 'Content' },
			component: () => import('@/components/clasificaciondeudores/ClasificacionDeudores')
		},
		{
			path: '/DeudaConcentrada',
			name: 'DeudaConcentrada',
			meta: { layout: 'Content' },
			component: () => import('@/components/deudaconcentrada/DeudaConcentrada')
		},
		// NOTIFICACIONES
		{
			path: '/Notificaciones/AvisoCesion',
			name: 'AvisoCesion',
			meta: { layout: 'Content' },
			component: () => import('@/components/notificacion/AvisoCesion')
		},
		{
			path: '/Notificaciones/Vencimiento',
			name: 'Vencimiento',
			meta: { layout: 'Content' },
			component: () => import('@/components/notificacion/Vencimiento')
		},
		{
			path: '/Notificaciones/Emitidos',
			name: 'Emitidas',
			meta: { layout: 'Content' },
			component: () => import('@/components/notificacion/Emitidos')
		},
		// CASTIGADOS
		{
			path: '/Castigados/Listado',
			name: 'CastigadosListado',
			meta: { layout: 'Content' },
			component: () => import('@/components/castigados/Listado')
		},
		{
			path: '/Castigados/Carga',
			name: 'CastigadosCarga',
			meta: { layout: 'Content' },
			component: () => import('@/components/castigados/Carga')
		},
		{
			path: '/Castigados/Detalle',
			name: 'CastigadosDetalle',
			meta: { layout: 'Content' },
			component: () => import('@/components/castigados/Detalle')
		},
		{
			path: '/Castigados/DetalleEmpresa',
			name: 'CastigadosDetalleEmpresa',
			meta: { layout: 'Content' },
			component: () => import('@/components/castigados/DetalleEmpresa')
		},
		{
			path: '/Mantenedor/Conformidad/Listado',
			name: 'ConformidadList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/conformidad/List')
		},
		{
			path: '/Mantenedor/Conformidad/Crear',
			name: 'ConformidadCreate',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/conformidad/PageForm')
		},
		{
			path: '/Mantenedor/Conformidad/Editar',
			name: 'ConformidadEdit',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/conformidad/PageForm')
		},
		{
			path: '/Mantenedor/Excepciones/Listado',
			name: 'ExcepcionesList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/excepciones/List')
		},
		{
			path: '/Mantenedor/Excepciones/Crear',
			name: 'ExcepcionesCreate',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/excepciones/PageForm')
		},
		{
			path: '/Mantenedor/Excepciones/Editar',
			name: 'ExcepcionesEdit',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/excepciones/PageForm')
		},
		{
			path: '/Mantenedor/Tramos/Listado',
			name: 'TramosList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/tramos/List')
		},
		{
			path: '/Mantenedor/Tramos/Crear',
			name: 'TramosCreate',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/tramos/PageForm')
		},
		{
			path: '/Mantenedor/Tramos/Editar',
			name: 'TramosEdit',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/tramos/PageForm')
		},
		{
			path: '/Mantenedor/Rubros/Listado',
			name: 'RubrosList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/rubros/List')
		},
		{
			path: '/Mantenedor/Rubros/Crear',
			name: 'RubrosCreate',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/rubros/PageForm')
		},
		{
			path: '/Mantenedor/Rubros/Editar',
			name: 'RubrosEdit',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/rubros/PageForm')
		},
		{
			path: '/Mantenedor/Bolsa/DeudoresBloqueados/Listado',
			name: 'BolsaDeudoresBloueadosList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/bolsa/deudores_bloqueados/List')
		},
		{
			path: '/Reportes/InformeFactoringPeru',
			name: 'InformeFactoringPeru',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/InformeFactoringPeru')
		},
		{
			path: '/Reportes/CargaHistoricoCavali',
			name: 'CargaHistoricoCavali',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/CargaHistoricoCavali')
		},
		{
			path: '/Reportes/CargaLetrasCavali',
			name: 'CargaLetrasCavali',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/CargaLetrasCavali')
		},
		{
			path: '/Reportes/CargaBolsaCavali',
			name: 'CargaBolsaCavali',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/CargaBolsaCavali')
		},
		{
			path: '/Reportes/EnvioEmails',
			name: 'ReportesEnvioEmails',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/EnvioEmails')
		},
		{
			path: '/Reportes/DeudaConcentrada',
			name: 'ReportesDeudaConcentrada',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/DeudaConcentrada')
		},
		{
			path: '/Credito/Detalle/:cred',
			name: 'DetalleCredito',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichagestion/DetalleCredito')
		},
		{
			path: '/Mantenedor/CuentasEjecutivos',
			name: 'CuentasEjecutivosList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/cuentas_ejecutivas/List')
		},
		{
			path: '/Mantenedor/Franquiciados',
			name: 'FranquiciadosList',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/franquiciados/List')
		},
		{
			path: '/CobranzaAutomatizada',
			name: 'CobranzaAutomatizada',
			meta: { layout: 'Content' },
			component: () => import('@/components/creditos/CobranzaAutomatizada')
		},
		{
			path: '/Carga/ConfirmacionCobranza',
			name: 'CargaConfirmacionCobranza',
			meta: { layout: 'Content' },
			component: () => import('@/components/creditos/CargaConfirmacionCobranza')
		},
		{
			path: '/Carga/Dicom',
			name: 'CargaDicom',
			meta: { layout: 'Content' },
			component: () => import('@/components/creditos/CargaDicom')
		},
		{
			path: '/Carga/Sinacofi',
			name: 'CargaSinacofi',
			meta: { layout: 'Content' },
			component: () => import('@/components/creditos/CargaSinacofi')
		},
		{
			path: '/HojaRuta/List',
			name: 'HojaRuta',
			meta: { layout: 'Content' },
			component: () => import('@/components/hoja_ruta/List')
		},
		{
			path: '/Admin/Usuarios',
			name: 'Usuarios',
			meta: { layout: 'Content' },
			component: () => import('@/components/usuarios/index')
		},
		{
			path: '/Perfil',
			name: 'Perfil',
			meta: { layout: 'Content' },
			component: () => import('@/components/usuarios/perfil')
		},
		{
			path: '/Empresa',
			name: 'Empresa',
			meta: { layout: 'Content' },
			component: () => import('@/components/mantenedor/empresa/Empresa')
		},
		{
			path: '/CargaNominaBanco',
			name: 'CargaNominaBanco',
			meta: { layout: 'Content' },
			component: () => import('@/components/CargaNominaBanco')
		},
		{
			path: '/FacturadorEfacobb',
			name: 'EfacobbAcesso',
			meta: { layout: 'Content' },
			component: () => import('@/components/FacturadorEfacobb')
		},
		{
			path: '*',
			redirect: '/Login'
		},
		{
			path: '/DespublicarDicom',
			name: 'DespublicarDicom',
			meta: { layout: 'Content' },
			component: () => import('@/components/DespublicarDicom')
		},
		{
			path: '/FichaAcumulacionCartera',
			name: 'FichaAcumulacionCartera',
			meta: { layout: 'Content' },
			component: () => import('@/components/fichacliente/FichaAcumulacionCartera')
		},
		// Administracion Cobranza (Menú)
		{
			path: '/EstimacionPago',
			name: 'EstimacionPago',
			meta: { layout: 'Content' },
			component: () => import('@/components/administracionCobranza/estimacionpago/EstimacionPago')
		},
		{
			path: '/Seguros/Polizas',
			name: 'Polizas',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/polizas/index')
		},
		{
			path: '/Seguros/Siniestros',
			name: 'Siniestros',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/siniestros/index')
		},
		{
			path: '/Seguros/Facturas',
			name: 'Facturas',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/facturas/index')
		},
		{
			path: '/Seguros/DevolucionPrimaNoconsumida',
			name: 'DevolucionPrima',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/devolucion_prima/index')
		},
		{
			path: '/Seguros/Bienes',
			name: 'Bienes',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/bienes/index')
		},
		{
			path: '/Seguros/CargaBienesMasivo',
			name: 'CargaBienesMasivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/seguros/cargaBienesMasivo/index')
		},
		{
			path: '/Ejemplo',
			name: 'Ejemplo',
			meta: { layout: 'Content' },
			component: () => import('@/components/ejemplo/index')
		},
		{
			path: '/GestionesHistoricas',
			name: 'GestionesHistoricas',
			meta: { layout: 'LayoutFichaCliente' },
			component: () => import('@/components/fichagestion/GestionesHistoricasOpen')
		},
		{
			path: '/ContactosEmpresa',
			name: 'ContactosEmpresa',
			meta: { layout: 'LayoutFichaCliente' },
			component: () => import('@/components/fichacliente/ContactosEmpresaOpen')
		},
		{
			path: '/Reportes/MoraDocumentos',
			name: 'MoraDocumentos',
			meta: { layout: 'Content' },
			component: () => import('@/components/reportes/MoraDocumentos')
		},
		{
			path: '/Contabilidad',
			name: 'Contabilidad',
			meta: { layout: 'Content' },
			component: () => import('@/components/contabilidad/index')
		},
		{
			path: '/ContabilidadPeru',
			name: 'ContabilidadPeru',
			meta: { layout: 'Content' },
			component: () => import('@/components/contabilidad/indexPeru')
		}
	]
})

// FUNCION QUE VALIDA EL TOKEN
async function ValidaToken (tokenAcceso) {
	let respuestaToken = false
	try {
		await axios.post(store.state.apiurl + 'Login/validarToken', {
			token: tokenAcceso
		}).then(response => {
			if (response.data.respuesta_token) {
				respuestaToken = true
			} else {
				respuestaToken = false
			}
		}).catch(error => {
			if (error.response.data.respuesta_token) {
				respuestaToken = true
			} else {
				respuestaToken = false
			}
		})
	} catch (error) {
		respuestaToken = false
	}

	return respuestaToken
}

router.beforeEach(async (to, from, next) => {
	// VALIDA SI VIENE DE UN LAYOUT ABIERTO SIN VALIDACION DE TOKEN
	if (to.meta.layout === 'LayoutFichaCliente') {
		next()
	} else {
		store.dispatch('fetchAccessToken')
		let validaToken = false
		if (store.state.accessToken) {
			if (await ValidaToken(store.state.accessToken)) {
				validaToken = true
			} else {
				validaToken = false
			}
		}

		if (validaToken) {
			store.dispatch('fetchAccessMenu')
			// SI EL TOKEN ES VALIDO
			if (to.fullPath === '/Login') {
				next('/Resumen')
			} else {
				next()
			}
		} else {
			// SI EL TOKEN ES INVALIDO
			if (to.fullPath === '/Login') {
				next()
			} else {
				store.dispatch('logoutError')
				next('/Login')
			}
		}
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js